import {
    getData,
} from './Services'

export const getDepartamentos = async (id) => {
    const res = await getData(`/departamentos/departamentos_select/${id}`);
    const departamentosTransformados = res
        .filter(p => p.depa_descripcion) // filtra los nulos
        .map(p => {
            const descripcion = p.depa_descripcion.toLowerCase()
                .replace(/\b\w/g, l => l.toUpperCase()); // Capitaliza cada palabra
            return {
                id: p.id,
                value: {
                    id: p.id,
                    descripcion,
                },
                label: descripcion
            };
        });
    return departamentosTransformados
}